// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KeypadButtons_wrapper__1x6vP","keypad-buttons-1-grid":"KeypadButtons_keypad-buttons-1-grid__28wrt","keypad-buttons-2-grid":"KeypadButtons_keypad-buttons-2-grid__3-lti"};